import { NoValue } from 'components/no_value/NoValue';

export function SerialNumber({
    value,
    fallbackOverride,
}: {
    value: string | undefined;
    fallbackOverride?: JSX.Element | undefined;
}): JSX.Element {
    if (value === undefined) {
        return fallbackOverride ?? <NoValue />;
    }
    if (value.trim() === '') {
        return <>BLANK SERIAL NUMBER</>;
    }
    return <code>{value}</code>;
}
